function init(converter = () => {}) {
    function api(key, value, attributes = {}) {
        let result;

        if (typeof document === 'undefined') {
            return;
        }

        // Write

        if (arguments.length > 1) {
            attributes = {
                path: '/',
                ...api.defaults,
                ...attributes,
            };

            if (typeof attributes.expires === 'number') {
                const expires = new Date();
                expires.setMilliseconds(
                    expires.getMilliseconds() + attributes.expires * 864e5
                );
                attributes.expires = expires;
            }

            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires
                ? attributes.expires.toUTCString()
                : '';

            try {
                result = JSON.stringify(value);
                // Tests to see if `result is a valid `JSON.stringify`'ed Array or Object
                // before overwriting `value` with `result`
                if (/^[\{\[]/.test(result)) {
                    value = result;
                }
            } catch (e) {
                // do nothing
            }

            if (!converter.write) {
                value = encodeURIComponent(String(value)).replace(
                    /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                    decodeURIComponent
                );
            } else {
                value = converter.write(value, key);
            }

            key = encodeURIComponent(String(key));
            key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
            key = key.replace(/[\(\)]/g, escape);

            const extraAttributes = [];

            for (const [attrKey, attrVal] of Object.entries(attributes)) {
                if (attrVal) {
                    const attr = [attrKey];

                    if (attrVal !== true) {
                        attr.push(String(attrVal).split(';')[0]);
                    }

                    extraAttributes.push(attr);
                }
            }

            // eslint-disable-next-line consistent-return
            return (document.cookie = `${key}=${value}; ${extraAttributes
                .map((attr) => attr.join('='))
                .join('; ')}`);
        }

        // Read

        if (!key) {
            result = {};
        }

        // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all. Also prevents odd result when
        // calling "get()"
        const cookies = document.cookie ? document.cookie.split('; ') : [];
        const rdecode = /(%[0-9A-Z]{2})+/g;

        cookies.some((cookie) => {
            const [cKey, ...rest] = cookie.split('=');
            let cVal = rest.join('=');

            if (!this.json && cVal.charAt(0) === '"') {
                cVal = cVal.slice(1, -1);
            }

            try {
                const name = cKey.replace(rdecode, decodeURIComponent);

                cVal = converter.read
                    ? converter.read(cVal, name)
                    : converter(cVal, name) ||
                      cVal.replace(rdecode, decodeURIComponent);

                if (this.json) {
                    try {
                        cVal = JSON.parse(cVal);
                    } catch (e) {
                        // do nothing
                    }
                }

                if (key === name) {
                    result = cVal;
                    return true;
                }

                if (!key) {
                    result[name] = cVal;
                }
            } catch (e) {
                // do nothing
            }

            return false;
        });

        return result; // eslint-disable-line consistent-return
    }

    api.set = api;
    api.get = (key) => api.call(api, key);
    api.getJSON = (...args) => api.call({json: true}, ...args);

    api.defaults = {};

    api.remove = (key, attributes = {}) =>
        api(key, '', {...attributes, expires: -1});

    api.removeAll = () => {
        for (const key of Object.keys(api.get())) {
            api.remove(key, {path: ''});
        }
    };

    api.withConverter = init;

    return api;
}

const api = init();

export default api;
